// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"a9a01df4","848":"6c7afa1c"}[chunkId] + ".chunk.css";
};